import React from 'react'
import { useForm } from 'react-hook-form'
import ModalContent from './modal_content'
import FlatButton from '../buttons/flat_button'
import { TextareaInput } from '../form/inputs/TextareaInput'
import { FormField } from '../form'

interface BusinessIdeaGenerateModalProps {
  isOpen: boolean
  onClose: () => void
  onGenerate: (aiInstruction: string | null) => void
  isGenerating: boolean
}

type FormData = {
  aiInstruction: string
}

const BusinessIdeaGenerateModal: React.FC<BusinessIdeaGenerateModalProps> = ({
  isOpen,
  onClose,
  onGenerate,
  isGenerating,
}) => {
  const { register, handleSubmit, reset } = useForm<FormData>({
    defaultValues: {
      aiInstruction: '',
    },
  })

  const onSubmit = (data: FormData) => {
    const instruction = data.aiInstruction.trim() || null
    onGenerate(instruction)
  }

  const handleClose = () => {
    if (!isGenerating) {
      reset()
      onClose()
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div onClick={(e) => e.stopPropagation()}>
        <ModalContent
          title="事業アイデア自動生成"
          onClose={isGenerating ? undefined : handleClose}
          className="w-full max-w-lg"
        >
          <form onSubmit={handleSubmit(onSubmit)} className="p-6">
            <div className="mb-6">
              <p className="mb-1">
                AIが企業情報を基に事業アイデアを自動生成します。
              </p>
              <p className="mb-8">
                ご要望や優先事項がございましたら、以下にご記載ください。
              </p>

              <FormField label="AI への指示文">
                <TextareaInput register={register('aiInstruction')} />
              </FormField>
            </div>

            <div className="flex gap-3 justify-end">
              <FlatButton
                onClick={handleClose}
                disabled={isGenerating}
                outline
                type="button"
              >
                キャンセル
              </FlatButton>
              <FlatButton type="submit" disabled={isGenerating}>
                {isGenerating ? '生成中...' : '生成開始'}
              </FlatButton>
            </div>
          </form>
        </ModalContent>
      </div>
    </div>
  )
}

export default BusinessIdeaGenerateModal
